import slide from './Slide'

const selfSlide = {
  install: Vue => {
    Vue.component('mySlide', slide)
  }
}

export default selfSlide



// WEBPACK FOOTER //
// ./src/components/slide/index.js